import { render, staticRenderFns } from "./GooglePlatformIcon.vue?vue&type=template&id=7cdeb8ba&scoped=true"
import script from "./GooglePlatformIcon.vue?vue&type=script&lang=js"
export * from "./GooglePlatformIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cdeb8ba",
  null
  
)

export default component.exports